"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../..");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./Checkbox.css");

var _styles = {
  "container": "Checkbox__container___3c2Tn",
  "no-margin": "Checkbox__no-margin___2uVzc",
  "disabled": "Checkbox__disabled___55m5F",
  "checkmark": "Checkbox__checkmark___1fifT",
  "small": "Checkbox__small___1hSxY"
};

const styles = _bind.default.bind(_styles);

const Checkbox = (0, _mobxReact.observer)(({
  className,
  onChange,
  options = [],
  small = false,
  fontWeight = 'medium',
  dataTestId,
  noMargin,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('wrapper', className));
  return _react.default.createElement("div", {
    className: composed_classname,
    ...props,
    "data-testid": dataTestId
  }, options.map(({
    text,
    value,
    checked,
    disabled = false
  }) => {
    return _react.default.createElement("label", {
      className: styles('container', {
        'no-margin': noMargin
      }),
      key: value
    }, _react.default.createElement(_.Text, {
      className: styles('label', {
        disabled
      }),
      size: small ? 13 : 15,
      tag: 'span',
      variant: fontWeight
    }, text), _react.default.createElement("input", {
      "data-testid": dataTestId && `${dataTestId}-${value}`,
      checked: checked,
      disabled: disabled,
      onChange: onChange,
      type: 'checkbox',
      value: value,
      tabIndex: 0
    }), _react.default.createElement("span", {
      className: styles('checkmark', {
        small,
        disabled
      })
    }));
  }));
});
var _default = Checkbox;
exports.default = _default;